import {uploadUrlToOSS} from "@/components/file_process_js/api";
import {getPCBFFileThumbnailUrlFromPath} from "@/components/thumbnail/getFlieThumbnailUrl"
import {fileStatusChange, getBaseName} from "@/components/file_process_js/utils";


export async function gbrFileVisionProcess(fileInfo) {
    const url = await getPCBFFileThumbnailUrlFromPath(fileInfo.file_path);
    // const targetScale = fileInfo.file_size/ (1024 * 512)
    const pngUrl = await svgToImage(url)
    const imageKey = `${getBaseName(fileInfo.file_path)}.jpeg`
    if (url) {
        try {
            fileStatusChange(fileInfo, "img uploading", 110)
            const uploadRes = await uploadUrlToOSS(fileInfo.project_id, pngUrl, imageKey)
            if (uploadRes.error) {
                console.error("uploadUrlToOSS error", uploadRes.error)
                fileStatusChange(fileInfo, "img_upload_failed", -112)
                return ""
            } else {
                fileStatusChange(fileInfo, "img_uploaded", 109)
                return imageKey
            }
        } catch (err) {
            console.error("gbrFileVisionProcess error", err)
            fileStatusChange(fileInfo, "img_upload_failed", -111)
            return ""
        }
    }
}



function svgToImage(svgUrl, targetScale) {
    // 返回一个新的 Promise
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            try {
                const canvas = document.createElement('canvas');
                // 为了更好的清晰度，可以考虑放大倍数
                const scale = 2;
                // const scale = window.devicePixelRatio || 1;
                console.log("window.devicePixelRatio", scale);
                canvas.width = img.width * scale;
                canvas.height = img.height * scale;
                const ctx = canvas.getContext('2d');

                // 【关键步骤】在绘制任何内容之前，先将整个画布填充为白色
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // 现在画布的背景已经是纯白色了，我们再在上面绘制SVG图像
                ctx.scale(scale, scale);
                ctx.drawImage(img, 0, 0);

                // 现在导出为 JPG，因为背景已经手动设为白色，所以不会再有黑色背景的问题
                // 第二个参数是图片质量 (0.0 到 1.0)，通常 0.95 就足够了
                const imgDataUrl = canvas.toDataURL('image/jpeg', 0.95);

                resolve(imgDataUrl);
            } catch (e) {
                console.error("svgToImage", e);
                reject(e);
            }
        };
        img.onerror = function (err) {
            reject(new Error(`Failed to load SVG image from URL: ${svgUrl}`));
        }
        img.crossOrigin = 'anonymous';
        img.src = svgUrl;
    });
}


